var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 8,
    viewBox: "0 0 7 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.77919 0.977624H5.12178L4.99195 0.719344C4.96444 0.664126 4.92208 0.617678 4.86962 0.585226C4.81716 0.552773 4.75668 0.535603 4.69499 0.535647H3.11631C3.05476 0.53541 2.99439 0.552516 2.94211 0.585005C2.88984 0.617494 2.84777 0.664052 2.82073 0.719344L2.6909 0.977624H1.03349C0.974879 0.977624 0.918669 1.00091 0.877226 1.04235C0.835783 1.08379 0.8125 1.14 0.8125 1.19861V1.64059C0.8125 1.6992 0.835783 1.75541 0.877226 1.79685C0.918669 1.8383 0.974879 1.86158 1.03349 1.86158H6.77919C6.8378 1.86158 6.89401 1.8383 6.93545 1.79685C6.9769 1.75541 7.00018 1.6992 7.00018 1.64059V1.19861C7.00018 1.14 6.9769 1.08379 6.93545 1.04235C6.89401 1.00091 6.8378 0.977624 6.77919 0.977624ZM1.54729 6.98575C1.55783 7.15406 1.63211 7.31203 1.75502 7.4275C1.87793 7.54297 2.04023 7.60726 2.20887 7.60728H5.60381C5.77245 7.60726 5.93474 7.54297 6.05766 7.4275C6.18057 7.31203 6.25485 7.15406 6.26539 6.98575L6.5582 2.30356H1.25448L1.54729 6.98575Z",
    fill: "#29AAE3",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.acc450ebeb5687a337991c8ac7a44641.svg";
export { ForwardRef as ReactComponent };